import { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import PulseLoader from "react-spinners/PulseLoader";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StyleIcon from "@mui/icons-material/Style";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import AdfScannerIcon from "@mui/icons-material/AdfScanner";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from "@mui/icons-material/Download";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiAvatar from "components/SuiAvatar";
import SuiBadge from "components/SuiBadge";
import ReadMore from "components/UpStyled/ReadMore";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { canResizeImageUrl } from "utils/imageHelper";
import DesignStage from "pages/de/styles/detail/components/DesignStage";
import DevelopStage from "pages/de/styles/detail/components/DevelopStage";
import ReferencesStage from "pages/de/styles/detail/components/ReferencesStage";
import CreateProjectPage from "pages/de/project/create-project";
import MarketResearch from "pages/de/styles/detail/components/MarketResearch";

import TabPanel from "components/UpStyled/TabPanel";

import { handleUploadFiles } from "utils/imageHelper";
import { isInPortfolio, checkPermission } from "utils/helper";

import CategoryContext from "context/category-context";
import { AccountContext } from "context/account";
import SharedContentContext from "context/shared-content";

import {
  useSoftUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

import toast from "react-hot-toast";
import api from "services/api";
import moment from "moment";
import qs from "query-string";

import breakpoints from "assets/theme/base/breakpoints";
import FullCreateStyleModal from "pages/de/project/create-project/components/FullCreateStyleModal";
import Error404 from "pages/error/404";
import NewSharedBar from "pages/de/share-page/newsharebar";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";

import StyleTutorialModal from "pages/tutorial/StyleTutorialModal";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import FolderIcon from "@mui/icons-material/Folder";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import StyleFileList from "pages/de/styles/detail/components/StyleFileList";

const initialStyle = {
  title: "Untitled",
  status: "design",
  description: "",
  options: [],
  collection_id: null,
  style: {
    style_number: "TEMP_" + moment().format("YYYYMMHHmmss"),
    year: moment().format("YYYY"),
  },
};
const StyleDetail = ({ sharedView = false }) => {
  const [detail, setDetail] = useState(initialStyle);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState("design");
  const [duplicateStyleVisible, setDuplicateStyleVisible] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [sampleTabVisible, setSampleTabVisible] = useState(false);
  const [editNameVisible, setEditNameVisible] = useState(false);
  const [inputWidth, setInputWidth] = useState(20);
  const [tutorialVisible, setTutorialVisible] = useState(false);
  const [currentStage, setCurrentStage] = useState("design");
  const [randomSeed, setRandomSeed] = useState();

  const [controller, dispatch] = useSoftUIController();
  const account = useContext(AccountContext);
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } = controller;

  const { permissionMap, retrieveContentPermission } = useContext(SharedContentContext);
  const collectionPermission = detail?.collection?.id
    ? permissionMap?.[detail.collection.id]
    : null;

  const shareSessionRef = useRef({});
  const styleNameInputRef = useRef(null);
  const designPanelRef = useRef(null);

  const urlParams = new URLSearchParams(window.location.search);
  let styleId = urlParams.get("id");
  let projectId = urlParams.get("pid");

  const action = urlParams.get("a");
  let stage = urlParams.get("stage") || "design";
  const techpackboard = urlParams.get("techpackboard");
  const imgid = urlParams.get("imgid");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let stage = urlParams.get("stage") || "design";
    setCurrentStage(stage);
  }, [window.location.search]);

  const navigate = useNavigate();
  const portfolio_content = account?.metadata?.portfolio_content;

  const stageMap = [
    { label: "Design", value: "design", icon: <StyleIcon fontSize="small" /> },
    { label: "Tech Pack", value: "tech-pack", icon: <DesignServicesIcon fontSize="small" /> },
    {
      label: "Sample",
      value: "sample",
      icon: <AdfScannerIcon fontSize="small" />,
      hide: !(
        ["active", "completed", "canceled"].includes(detail?.project_status) || sampleTabVisible
      ),
    },
    {
      label: "Market Research",
      value: "market",
      icon: <AnalyticsOutlinedIcon fontSize="small" />,
      hide: detail?.id ? false : true,
    },
  ];

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
           The event listener that's calling the handleTabsOrientation function when resizing the window.
          */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  useEffect(() => {
    setMiniSidenav(dispatch, true);
    return () => {
      setMiniSidenav(dispatch, false);
    };
  }, []);

  useEffect(() => {
    if (sharedView) {
      retrieveContentPermission();
    }
    if (detail.id) {
      ListProjectByStyle();
    }
  }, [detail.id]);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
      value: index,
    };
  }

  useEffect(() => {
    retrieveStyleDetail(styleId, projectId);
  }, [styleId]);

  const retrieveStyleDetail = async (styleId, projectId) => {
    try {
      setUploading(true);
      if (styleId && !projectId) {
        const { data } = await api.products.listStyles({ id: styleId });
        const products = data["products"] ? data["products"] : [];

        if (products.length > 0) {
          setDetail(products[0]);
        }
      } else if (styleId && projectId) {
        const { data } = await api.project.get(projectId);
        const project = data["project"] ? data["project"] : {};
        if (!project?.products) {
          project.products = [];
        }
        const product = project.products.find((x) => x.id == styleId);
        product.project_id = project.id;
        product.project_name = project.name;
        product.provider_id = project.provider_id;
        product.project_status = project.status;
        setDetail(product);
      }

      setUploading(false);
    } catch (err) {
      console.log(err);
      toast.error(`Retrieve style detail failed`);
      setUploading(false);
    }
  };

  const handleRefresh = async () => {
    await retrieveStyleDetail(styleId, projectId);
  };

  const ListProjectByStyle = async () => {
    try {
      const { data } = await api.products.listProjectsByStyle(detail.id);
      let myProjects = data?.product?.projects || [];

      for (let j = 0; j < myProjects.length; j++) {
        if (["active", "completed", "canceled"].includes(myProjects[j].status)) {
          setSampleTabVisible(true);
          return;
        }
      }
      setSampleTabVisible(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangeStyleName = async () => {
    let value = styleNameInputRef?.current?.value;
    value = value.trim();
    if (value == detail?.title || !value) {
      setEditNameVisible(false);
      return;
    }

    if (styleId) {
      try {
        //do update
        await api.products.update(styleId, { title: value });
        setDetail({ ...detail, title: value });
        toast.success("Update style name successfully!");
      } catch (err) {
        console.log(err);
        toast.error("Update style name failed!");
      }
    } else {
      setDetail({ ...detail, title: value });
    }

    setEditNameVisible(false);
  };

  const handleShowEditStyleName = () => {
    setEditNameVisible(true);
    setInputWidth(detail?.title?.length);
  };

  const canWrite = !sharedView;
  //||
  // (sharedView && checkPermission(detail?.id, detail?.collection_id, permissionMap));

  const handleClickStage = (value) => {
    var url = new window.URL(document.location); // fx. http://host.com/endpoint?abc=123
    url.searchParams.set("stage", value);
    window.history.replaceState("", "style", url.toString());
    setCurrentStage(value);
  };

  const handleChangeDesignFile = async (item) => {
    try {
      window.history.replaceState("", "style", `${window.location.pathname}?id=${item.id}`);
      setTabValue("design");
    } catch (err) {
      console.log(err);
    }
  };

  const handleRefreshComponent = async () => {
    setRandomSeed(Math.random());
  };

  if (!account.id) {
    return <div />;
  }

  return (
    <SuiBox key={randomSeed}>
      <div>
        <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
          <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
          <SuiTypography variant="h6" fontWeight="medium" color="info">
            Uploading supporting files...
          </SuiTypography>
        </Backdrop>
        <SuiBox>
          <NewSharedBar
            type="product"
            data={detail}
            shareSessionRef={shareSessionRef}
            handleRefreshSourceData={handleRefresh}
            title={
              <SuiBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ height: "100%" }}
              >
                {editNameVisible ? (
                  <div className="flex">
                    <input
                      size="small"
                      defaultValue={detail?.title || "Untitled"}
                      ref={styleNameInputRef}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleChangeStyleName();
                        }
                      }}
                      className="font-serif"
                      autoFocus
                      style={{
                        outline: "none",
                        border: "none",
                        width: inputWidth + "ch",
                        fontSize: "1.25rem",
                        lineHeight: 1.375,
                        fontWeight: 700,
                      }}
                      onChange={(e) => setInputWidth(e.target?.value?.length)}
                      onBlur={handleChangeStyleName}
                    />
                  </div>
                ) : (
                  <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                    <Tooltip title={canWrite && detail?.mode != 2 ? "Click to change name" : ""}>
                      <SuiTypography
                        variant="h5"
                        className="font-serif"
                        fontWeight="bold"
                        textTransform="none"
                        onClick={() =>
                          canWrite && detail?.mode != 2 ? handleShowEditStyleName() : null
                        }
                      >
                        {detail?.title}
                      </SuiTypography>
                    </Tooltip>
                  </SuiBox>
                )}

                <SuiTypography textTransform="none" color="secondary" className="font-serif">
                  {detail?.style?.style_number ? `(${detail?.style?.style_number})` : ""}
                </SuiTypography>
                {detail?.collection?.id ? (
                  <SuiTypography
                    component={collectionPermission ? Link : "div"}
                    color="secondary"
                    sx={{ ml: 2, "&:hover": { textDecoration: "underline" } }}
                    to={
                      sharedView && collectionPermission
                        ? `/shared-with-me/collections?id=${detail?.collection?.id}`
                        : `/workspace/collections?id=${detail?.collection?.id}`
                    }
                    className="font-serif"
                    fontWeight="bold"
                  >
                    {detail?.collection?.title}
                  </SuiTypography>
                ) : null}
                {isInPortfolio(detail?.id, portfolio_content) ? (
                  <SuiBadge
                    color="info"
                    variant="contained"
                    size="md"
                    badgeContent={"In Portfolio"}
                  />
                ) : null}
              </SuiBox>
            }
            extraAction={
              <PlayCircleIcon
                sx={{ cursor: "pointer", zIndex: 2 }}
                onClick={() => setTutorialVisible(true)}
                color="dark"
                fontSize="medium"
              />
            }
          />
        </SuiBox>
        <SuiBox display="flex" gap={2}>
          <SuiBox
            sx={{
              position: "sticky",
              top: 20,
              minWidth: { lg: 240, md: 240, sm: 170, xs: 170 },
              width: { lg: 240, md: 240, sm: 170, xs: 170 },
            }}
          >
            <Tabs
              value={tabValue}
              onChange={(e, v) => setTabValue(v)}
              aria-label="icon position tabs example"
              sx={{ mb: 0.5 }}
            >
              <Tab
                icon={<DesktopWindowsOutlinedIcon fontSize="small" />}
                iconPosition="start"
                label={
                  <SuiTypography
                    sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
                  >
                    Tools
                  </SuiTypography>
                }
                sx={{ fontSize: 14 }}
                {...a11yProps("design")}
              />
              <Tab
                icon={<FolderIcon fontSize="small" />}
                iconPosition="start"
                label={
                  <SuiTypography
                    sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
                  >
                    Folder
                  </SuiTypography>
                }
                sx={{ fontSize: 14 }}
                {...a11yProps("folder")}
              />
            </Tabs>
            <TabPanel value={tabValue} index={"design"}>
              <Card
                sx={{
                  borderRadius: 1,
                  mb: 2,
                  zIndex: 2,
                  boxShadow: ({ boxShadows: { md } }) => md,
                }}
              >
                <Grid container>
                  {stageMap
                    .filter((x) => !x?.hide)
                    .map((item, index) => (
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        key={index}
                        onClick={() => {
                          handleClickStage(item.value);
                        }}
                      >
                        <SuiBox
                          className={
                            currentStage == item.value
                              ? "model-function-button-active"
                              : "model-function-button-inactive"
                          }
                          sx={{
                            textAlign: "center",
                            width: "100%",
                            height: "100%",
                            margin: "auto",
                            lineHeight: 1.2,
                            cursor: "pointer",
                            "&:hover": {
                              backgroundColor: "#f3f3f3",
                            },
                          }}
                        >
                          {item.icon}
                          <SuiBox
                            sx={{
                              display: { xs: "none", sm: "none", md: "flex", lg: "flex" },
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 13,
                            }}
                          >
                            {item.label}
                          </SuiBox>
                        </SuiBox>
                      </Grid>
                    ))}
                </Grid>
              </Card>
            </TabPanel>
            <TabPanel value={tabValue} index={"folder"}>
              <StyleFileList
                handleClick={handleChangeDesignFile}
                currentItemId={detail.id}
                sharedView={sharedView}
                handleRefresh={handleRefreshComponent}
              />
            </TabPanel>
          </SuiBox>
          <div style={{ width: "100%" }}>
            <TabPanel value={currentStage} index={"design"}>
              <DesignStage
                detail={detail}
                handleRefresh={handleRefresh}
                accountType={account.account_type}
                handleNext={() => handleClickStage("tech-pack")}
                sharedView={sharedView}
                ref={designPanelRef}
              />
            </TabPanel>
            <TabPanel value={currentStage} index={"tech-pack"}>
              <DevelopStage
                detail={detail}
                handleRefresh={handleRefresh}
                techpackboard={techpackboard}
                shareSessionRef={shareSessionRef}
              />
            </TabPanel>
            {["active", "completed", "canceled"].includes(detail?.project_status) ||
            sampleTabVisible ? (
              <TabPanel value={currentStage} index={"sample"}>
                <ReferencesStage
                  detail={detail}
                  handleRefresh={handleRefresh}
                  accountType={account.account_type}
                  imgid={imgid}
                />
              </TabPanel>
            ) : null}
            {detail?.id ? (
              <TabPanel value={currentStage} index={"market"}>
                <MarketResearch
                  detail={detail}
                  handleRefresh={handleRefresh}
                  accountType={account.account_type}
                  sharedView={sharedView}
                />
              </TabPanel>
            ) : null}
          </div>
        </SuiBox>
      </div>

      {duplicateStyleVisible ? (
        <FullCreateStyleModal
          handleClose={() => setDuplicateStyleVisible(false)}
          //handleOk={(data) => handleDuplicateStyle(data)}
          visible={duplicateStyleVisible}
          isDuplicate={true}
          style={detail}
          handleRefresh={handleRefresh}
        />
      ) : null}
      {tutorialVisible ? (
        <StyleTutorialModal
          visible={tutorialVisible}
          handleClose={() => setTutorialVisible(false)}
        />
      ) : null}
    </SuiBox>
  );
};

export default StyleDetail;
